<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="商品：" prop="relatedGoodsId">
            <el-select style="width: 420px;" v-model="ruleForm.relatedGoodsId" placeholder="请选择商品">
              <el-option v-for="(item,index) in goodsList" :key="index" :label="item.relatedGoodsName" :value="item.relatedGoodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.goodsSpecRelatedPageVoList.length > 0" label="规格：" prop="goodsSpecRelatedPageVoList">
            <el-table
              :data="ruleForm.goodsSpecRelatedPageVoList"
              border
              style="width: 100%">
              <el-table-column
                prop="specName"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="specThumb"
                label="图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 32px;"
                    :src="scope.row.specThumb"
                    :preview-src-list="[scope.row.specThumb]"
                    fit="contain"></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiSpecPrice"
                label="售价">
              </el-table-column>
              <el-table-column
                prop="apiStockNum"
                label="库存">
              </el-table-column>
              <el-table-column
                prop="apiWeight"
                label="重量(kg)">
              </el-table-column>
              <el-table-column
                prop="volume"
                label="体积(m³)">
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAllEnableGoodsList, saveGoodsRelated } from '@/api/goods'
export default {
  name: 'RecommendGoodsAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      goodsList:[],
      ruleForm: {
        relatedGoodsId: '',
        goodsSpecRelatedPageVoList:[],
        sort: ''
      },
      rules: {
        relatedGoodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        goodsSpecRelatedPageVoList: [
          { required: true, message: '', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'ruleForm.relatedGoodsId': {
      handler(newVal, oldVal) {
        var that = this;
        that.goodsList.forEach(function(item){
          if(newVal == item.relatedGoodsId){
            that.ruleForm.goodsSpecRelatedPageVoList = item.goodsSpecRelatedPageVoList;
          }
        });
      }
    }
  },
  mounted () {
    this.goodsFun();
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 商品列表数据
    goodsFun(){
      let that = this
      queryAllEnableGoodsList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsList = data;
        }
      })
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let relatedGoodsId = that.ruleForm.relatedGoodsId
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (relatedGoodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      let passData = {
        goodsId: dataId, relatedGoodsId: relatedGoodsId, sort:sort
      }
      saveGoodsRelated(passData).then((res) => {
       that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/RecommendGoodsAdd.vue